import { transfers } from '@/socket'
import { mapState, mapActions } from 'vuex'

export default {
  mounted () {
    transfers.on('cash-in', async (message) => {
      this.setMeta('cashin')
      this.setNotif([ { key: 'cashin', value: true } ])

      // setTimeout(() => {
      //   this.setNotif([ { key:'cashin', value:  false } ])
      // }, 3000)
    })

    transfers.on('cash-out', async (message) => {
      this.setMeta('cashout')
      this.setNotif([ { key: 'cashout', value: true } ])

      // setTimeout(() => {
      //  this.setNotif([ { key:'cashout', value:  false } ])
      // }, 3000)
    })

    transfers.on('manual', async (message) => {
      await this.getManualInfo()
      await this.getCashInfo()
    })

    transfers.on('update-status', async (message) => {
      this.getAllMeta()
      this.getCashInfo()
    })
  },

  methods: {
    ...mapActions('transfer', ['get']),
    ...mapActions('meta', { getAllMeta: 'get', getCashInfo: 'getCashInfo' }),
    ...mapActions('meta', ['getCashInfo', 'setNotif', 'setMeta', 'getManualInfo'])
  }
}
